<template>
  <div id="periodicalRz">
    <div class="title">基本信息</div>
    <div class="list">
      <div class="key" style="position: relative">
        <span style="color: red; position: absolute; top: 3px; left: -15px"
          >*</span
        >期刊名称
      </div>
      <Input v-model="periodical.name" @on-blur="nameBlur" placeholder="" style="width: 300px" />
      <p style="color: red;margin-left: 5px;" v-if="isCertification">{{certificationMsg}}</p>
    </div>
    <div class="list">
      <div class="key" style="position: relative">
        <span style="color: red; position: absolute; top: 3px; left: -15px"
          >*</span
        >LOGO
      </div>
      <!--      <Input v-model="name" placeholder="" style="width: 300px" />-->
      <Upload
        accept=".png,.jpg,.jpeg"
        :headers="{ token: token }"
        :show-upload-list="false"
        class="upload"
        :format="['jpg', 'jpeg', 'png']"
        :max-size="1024"
        :on-exceeded-size="handleMaxSize"
        :action="`${$global.uplodeUrl}zw-public/web/common/upload`"
        :on-success="periodicalLogoSuccess"
      >
        <img
          class="img"
          style="width: 40px; height: 40px; border-radius: 50%"
          v-if="periodical.periodicalLogo.length !== 0"
          v-lazy="$global.imgUrl + periodical.periodicalLogo"
          alt
        />
        <img
          v-else
          style="width: 40px; height: 40px; border-radius: 50%"
          class="img"
          src="@/assets/img/userInfo/add.png"
          alt=""
        />
      </Upload>
    </div>
    <div class="list">
      <div class="key" style="position: relative">
        <span style="color: red; position: absolute; top: 3px; left: -15px"
          >*</span
        >封面图
      </div>
      <!--      <Input v-model="name" placeholder="" style="width: 300px" />-->
      <Upload
        accept=".png,.jpg,.jpeg"
        :headers="{ token: token }"
        :show-upload-list="false"
        class="upload"
        :format="['jpg', 'jpeg', 'png']"
        :max-size="1024"
        :on-exceeded-size="handleMaxSize"
        key="coverImg"
        :action="`${$global.uplodeUrl}zw-public/web/common/upload`"
        :on-success="coverImgSuccess"
      >
        <img
          class="img"
          v-if="periodical.coverImg.length !== 0"
          v-lazy="$global.imgUrl + periodical.coverImg"
          alt
        />
        <img v-else class="img" src="@/assets/img/userInfo/add.png" alt="" />
      </Upload>
      <div class="tishi">支持JPG、JPEG、PNG格式，图片不超过 1M</div>
    </div>
    <div class="list">
      <div class="key" style="position: relative">
        <span style="color: red; position: absolute; top: 3px; left: -15px"
          >*</span
        >创刊时间
      </div>
      <DatePicker
        :value="periodical.foundedDate"
        @on-change="changeDate"
        type="year"
        style="width: 300px"
      ></DatePicker>
    </div>
    <div class="list">
      <div class="key" style="position: relative">
        <span style="color: red; position: absolute; top: 3px; left: -15px"
          >*</span
        >主管单位
      </div>
      <div>
        <div class="netBox" v-for="(item,i) in periodical.responsibleDeptList" :key="i">
          <Input
            v-model="item.orgName"
            placeholder=""
            style="width: 300px"
          />
          <div v-show="(i===0 && periodical.responsibleDeptList.length>1)||i>0" class="addIcon subIcon" @click="delPeriodicalDatabase('responsibleDeptList',i)">-</div>
          <div v-show="periodical.responsibleDeptList.length-1 === i" class="addIcon" @click="addPeriodicalDatabase('responsibleDeptList',i)">+</div>
        </div>
      </div>
    </div>
    <div class="list">
      <div class="key" style="position: relative">
        <span style="color: red; position: absolute; top: 3px; left: -15px"
          >*</span
        >主办单位
      </div>
      <div>
        <div class="netBox" v-for="(item,i) in periodical.organizerList" :key="i">
          <Input
            v-model="item.orgName"
            placeholder=""
            style="width: 300px"
          />
          <div v-show="(i===0 && periodical.organizerList.length>1)||i>0" class="addIcon subIcon" @click="delPeriodicalDatabase('organizerList',i)">-</div>
          <div v-show="periodical.organizerList.length-1 === i" class="addIcon" @click="addPeriodicalDatabase('organizerList',i)">+</div>
        </div>
      </div>
    </div>
    <div class="list">
      <div class="key" style="position: relative">
        <span style="color: red; position: absolute; top: 3px; left: -15px"
          >*</span
        >出版单位
      </div>
      <div>
        <div class="netBox" v-for="(item,i) in periodical.publishCompanyList" :key="i">
          <Input
            v-model="item.orgName"
            placeholder=""
            style="width: 300px"
          />
          <div v-show="(i===0 && periodical.publishCompanyList.length>1)||i>0" class="addIcon subIcon" @click="delPeriodicalDatabase('publishCompanyList',i)">-</div>
          <div v-show="periodical.publishCompanyList.length-1 === i" class="addIcon" @click="addPeriodicalDatabase('publishCompanyList',i)">+</div>
        </div>
      </div>
    </div>
    <div class="list">
      <div class="key" style="position: relative">
        <span style="color: red; position: absolute; top: 3px; left: -15px"
          >*</span
        >出版周期
      </div>
      <Select style="width: 300px" v-model="periodical.publishPeriod">
        <Option :value="1"> 年刊 </Option>
        <Option :value="2"> 半年刊 </Option>
        <Option :value="3"> 季刊 </Option>
        <Option :value="4"> 双月刊 </Option>
        <Option :value="5"> 月刊 </Option>
        <Option :value="6"> 半月刊 </Option>
        <Option :value="7"> 旬刊 </Option>
        <Option :value="8"> 周刊 </Option>
        <Option :value="9"> 周二刊 </Option>
      </Select>
      <!--      <Input v-model="periodical.publishPeriod" placeholder="" style="width: 300px" />-->
    </div>
    <div class="list">
      <div class="key" style="position: relative">
        <span style="color: red; position: absolute; top: 3px; left: -15px"
          >*</span
        >国内统一连续出版物号
      </div>
      <Input v-model="periodical.cn" placeholder="" style="width: 300px" />
    </div>
    <div class="list">
      <div class="key" style="position: relative">
        <span style="color: red; position: absolute; top: 3px; left: -15px"
          >*</span
        >国际标准连续出版物号
      </div>
      <Input v-model="periodical.issn" placeholder="" style="width: 300px" />
    </div>
    <div class="list">
      <div class="key" style="position: relative">
        <span style="color: red; position: absolute; top: 3px; left: -15px"
          >*</span
        >国内邮发代号
      </div>
      <Input
        v-model="periodical.codeDomestic"
        placeholder=""
        style="width: 300px"
      />
    </div>
    <div class="list">
      <div class="key" style="position: relative">
        <span style="color: red; position: absolute; top: 3px; left: -15px"
          >*</span
        >期刊分类
      </div>
      <Select
        v-model="journal"
        style="width: 200px; margin-right: 5px"
        @on-change="journalChange"
      >
        <Option v-for="item in journalList" :key="item.id" :value="item.code">
          {{ item.name }}
        </Option>
      </Select>
      <Select v-model="journal2" style="width: 200px" @on-change="journalTwoChange">
        <Option v-for="item in journalList2" :key="item.id" :value="item.code">
          {{ item.name }}
        </Option>
      </Select>
    </div>
    <div style="flex-wrap: wrap" class="list">
      <div class="key" style="position: relative">
        <span style="color: red; position: absolute; top: 3px; left: -15px"
          >*</span
        >收录网站
      </div>
      <div>
        <div
          class="netBox"
          style="position: relative"
          v-for="(item, i) in periodicalDatabase"
          :key="i"
        >
          <Input
            v-model="item.name"
            placeholder="请输入网站名字"
            style="width: 100px"
          />
          <Input
            v-model="item.url"
            placeholder="请输入网站地址"
            style="width: 100px; margin-left: 10px; margin-right: 10px"
          />
          <div @click="delPeriodicalDatabase('periodicalDatabase',i)" v-show="(i===0 && periodicalDatabase.length>1)||i>0" class="addIcon subIcon">-</div>
          <div @click="addPeriodicalDatabase('periodicalDatabase',i)" v-show="periodicalDatabase.length-1 === i" class="addIcon">+</div>
        </div>
      </div>
    </div>
    <div class="list">
      <div class="key" style="position: relative">
        收录数据库
      </div>
      <CheckboxGroup v-model.trim="periodical.coreName">
        <Checkbox
          v-for="v in includeList"
          :key="v.id"
          :label="v.dbName"
        ></Checkbox>
      </CheckboxGroup>
    </div>
    <div class="list">
      <div class="key" style="position: relative">
        <span style="color: red; position: absolute; top: 3px; left: -15px"
          >*</span
        >出版地
      </div>
      <Select
        style="width: 200px; margin-right: 5px"
        v-model="pre"
        @on-change="handerChange"
      >
        <Option v-for="item in preList" :key="item.id" :value="item.code">
          {{ item.name }}
        </Option>
      </Select>
      <Select style="width: 200px" v-model="city" @on-change="handerChangeCity">
        <Option v-for="item in cityList" :key="item.id" :value="item.code">
          {{ item.name }}
        </Option>
      </Select>
    </div>
    <div class="list">
      <div class="key" style="position: relative">
        <span style="color: red; position: absolute; top: 3px; left: -15px"
          >*</span
        >E-mail
      </div>
      <Input v-model="periodical.email" placeholder="" style="width: 300px" />
    </div>
    <div style="margin-top: 50px" class="title">资质信息</div>
    <div class="list">
      <div class="key" style="position: relative">
        <span style="color: red; position: absolute; top: 3px; left: -15px"
          >*</span
        >营业执照
      </div>
      <!--      <Input v-model="name" placeholder="" style="width: 300px" />-->
      <Upload
        accept=".png,.jpg,.jpeg"
        :headers="{ token: token }"
        :show-upload-list="false"
        class="upload"
        :format="['jpg', 'jpeg', 'png']"
        :max-size="1024"
        :on-exceeded-size="handleMaxSize"
        :action="`${$global.uplodeUrl}zw-public/web/common/upload`"
        :on-success="businessLicenseSuccess"
      >
        <img
          class="img"
          v-if="periodicalInfo.businessLicense.length !== 0"
          v-lazy="$global.imgUrl + periodicalInfo.businessLicense"
          alt
        />
        <img v-else class="img" src="@/assets/img/userInfo/add.png" alt="" />
      </Upload>
      <div class="tishi">支持JPG、JPEG、PNG格式，图片不超过 1M</div>
    </div>
    <div class="list">
      <div class="key" style="position: relative">
        <span style="color: red; position: absolute; top: 3px; left: -15px"
          >*</span
        >期刊出版许可证
      </div>
      <!--      <Input v-model="name" placeholder="" style="width: 300px" />-->
      <Upload
        accept=".png,.jpg,.jpeg"
        :headers="{ token: token }"
        :show-upload-list="false"
        class="upload"
        :format="['jpg', 'jpeg', 'png']"
        :max-size="1024"
        :on-exceeded-size="handleMaxSize"
        :action="`${$global.uplodeUrl}zw-public/web/common/upload`"
        :on-success="pulicationLicenseSuccess"
      >
        <img
          class="img"
          v-if="periodicalInfo.publicationLicense.length !== 0"
          v-lazy="$global.imgUrl + periodicalInfo.publicationLicense"
          alt
        />
        <img v-else class="img" src="@/assets/img/userInfo/add.png" alt="" />
      </Upload>
      <div class="tishi">支持JPG、JPEG、PNG格式，图片不超过 1M</div>
    </div>
    <div class="list">
      <div class="key" style="position: relative">
        <span style="color: red; position: absolute; top: 3px; left: -15px"
          >*</span
        >岗位培训证
      </div>
      <!--      <Input v-model="name" placeholder="" style="width: 300px" />-->
      <Upload
        accept=".png,.jpg,.jpeg"
        :headers="{ token: token }"
        :show-upload-list="false"
        class="upload"
        :format="['jpg', 'jpeg', 'png']"
        :max-size="1024"
        :on-exceeded-size="handleMaxSize"
        :action="`${$global.uplodeUrl}zw-public/web/common/upload`"
        :on-success="jobsTrainingCertificateSuccess"
      >
        <img
          class="img"
          v-if="periodicalInfo.jobsTrainingCertificate.length !== 0"
          v-lazy="$global.imgUrl + periodicalInfo.jobsTrainingCertificate"
          alt
        />
        <img v-else class="img" src="@/assets/img/userInfo/add.png" alt="" />
      </Upload>
      <div class="tishi">支持JPG、JPEG、PNG格式，图片不超过 1M</div>
    </div>
    <div class="list">
      <div class="key" style="position: relative">
        <!-- <span style="color: red; position: absolute; top: 3px; left: -15px">*</span> -->
        责任编辑证
      </div>
      <!--      <Input v-model="name" placeholder="" style="width: 300px" />-->
      <Upload
        accept=".png,.jpg,.jpeg"
        :headers="{ token: token }"
        :show-upload-list="false"
        class="upload"
        :format="['jpg', 'jpeg', 'png']"
        :max-size="1024"
        :on-exceeded-size="handleMaxSize"
        :action="`${$global.uplodeUrl}zw-public/web/common/upload`"
        :on-success="advertiseLicenceSuccess"
      >
        <img
          class="img"
          v-if="periodicalInfo.advertiseLicense.length !== 0"
          v-lazy="$global.imgUrl + periodicalInfo.advertiseLicense"
          alt
        />
        <img v-else class="img" src="@/assets/img/userInfo/add.png" alt="" />
      </Upload>
      <div class="tishi">支持JPG、JPEG、PNG格式，图片不超过 1M</div>
    </div>
    <div class="list">
      <div class="key">广告许可证</div>
      <Upload
        accept=".png,.jpg,.jpeg"
        :headers="{ token: token }"
        :show-upload-list="false"
        class="upload"
        :format="['jpg', 'jpeg', 'png']"
        :max-size="1024"
        :on-exceeded-size="handleMaxSize"
        :action="`${$global.uplodeUrl}zw-public/web/common/upload`"
        :on-success="dutyCompilerCertificateSuccess"
      >
        <img
          class="img"
          v-if="periodicalInfo.dutyCompilerCertificate.length !== 0"
          v-lazy="$global.imgUrl + periodicalInfo.dutyCompilerCertificate"
          alt
        />
        <img v-else class="img" src="@/assets/img/userInfo/add.png" alt="" />
      </Upload>
      <!--      <Input v-model="name" placeholder="" style="width: 300px" />-->
      <div class="tishi">支持JPG、JPEG、PNG格式，图片不超过 1M</div>
    </div>
    <div style="margin-top: 50px" class="title">运营者信息</div>
    <div class="list">
      <div class="key" style="position: relative">
        <span style="color: red; position: absolute; top: 3px; left: -15px"
          >*</span
        >运营者姓名
      </div>
      <Input
        v-model="periodicalInfo.operateName"
        placeholder=""
        style="width: 300px"
      />
    </div>
    <div class="list">
      <div class="key" style="position: relative">
        <span style="color: red; position: absolute; top: 3px; left: -15px"
          >*</span
        >运营者身份证号
      </div>
      <Input
        v-model="periodicalInfo.operateIdentityCard"
        placeholder=""
        style="width: 300px"
      />
    </div>
    <div class="list" style="align-items: flex-start">
      <div class="key" style="position: relative">
        <span style="color: red; position: absolute; top: 3px; left: -15px"
          >*</span
        >运营者身份证图片
      </div>
      <Upload
        accept=".png,.jpg,.jpeg"
        :headers="{ token: token }"
        :show-upload-list="false"
        class="upload"
        :format="['jpg', 'jpeg', 'png']"
        :max-size="1024"
        :on-exceeded-size="handleMaxSize"
        :action="`${$global.uplodeUrl}zw-public/web/common/upload`"
        :on-success="operateIdentityImgFrontSuccess"
      >
        <img
          class="IDimg"
          v-if="periodicalInfo.operateIdentityImgFront.length !== 0"
          v-lazy="$global.imgUrl + periodicalInfo.operateIdentityImgFront"
          alt
        />
        <img v-else class="IDimg" src="@/assets/img/userInfo/zid.png" alt="" />
      </Upload>
      <Upload
        accept=".png,.jpg,.jpeg"
        :headers="{ token: token }"
        :show-upload-list="false"
        style="margin-left: 20px"
        class="upload"
        :format="['jpg', 'jpeg', 'png']"
        :max-size="1024"
        :on-exceeded-size="handleMaxSize"
        :action="`${$global.uplodeUrl}zw-public/web/common/upload`"
        :on-success="operateIdentityImgBackSuccess"
      >
        <img
          class="IDimg"
          v-if="periodicalInfo.operateIdentityImgBack.length !== 0"
          v-lazy="$global.imgUrl + periodicalInfo.operateIdentityImgBack"
          alt
        />
        <img v-else class="IDimg" src="@/assets/img/userInfo/fid.png" alt="" />
      </Upload>
      <!--      <Input v-model="operateIdentityCard" placeholder="" style="width: 300px" />-->
    </div>
    <div style="qmargin-left: 300px; margin-top: 20px" class="tishi">
      支持JPG、JPEG、PNG格式，图片不超过 1M
    </div>
    <div style="text-align: center;margin-top: 50px;">
      <Button v-throttleClick @click="sub" class="submit">提交</Button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "index",
  computed: {
    ...mapState(["token"]),
  },
  data() {
    return {
      isCertification: false,
      certificationMsg: "",
      pre: "",
      preList: [],
      city: "",
      cityList: [],
      journal: "", // 分类一级标签
      journalList: [], // 期刊分类一级下拉选项
      journal2: "", // 分类二级标签
      journalList2: [], // 期刊分类二级下拉选项
      periodical: {
        name: "",
        coverImg: "",
        foundedDate: "",
        responsibleDeptList: [{orgName: ""}],
        organizerList: [{orgName: ""}],
        publishCompanyList: [{orgName: ""}],
        publishPeriod: "",
        cn: "",
        issn: "",
        subjectId: "",
        codeDomestic: "",
        periodicalLogo: "",
        coreName: [],
        publishAddrProvince: "",
        publishAddrCity: "",
        email: "",
        id: "",
        adminUser: "",
        subject: "",
      },
      periodicalInfo: {
        operateName: "",
        operateIdentityCard: "",
        operateIdentityImgBack: "",
        operateIdentityImgFront: "",
        businessLicense: "",
        publicationLicense: "",
        dutyCompilerCertificate: "",
        jobsTrainingCertificate: "",
        advertiseLicense: "",
        id: "",
      },
      periodicalDatabase: [
        {
          url: "",
          name: "",
        },
      ],
      includeList: [],
    };
  },
  async created() {
    await this.classificationOneList();
    await this.getIncludeList();
    await this.getProList();
    let userHasData = JSON.parse(sessionStorage.getItem("userHasData"));
    if (userHasData.status === 2) {
      this.getMaDetails();
    }
  },
  methods: {
    async nameBlur() {
      if (this.periodical.name !== '') {
        let res = await this.$apis.userServe.isNameExist({
          name: this.periodical.name
        });
        if (res.resultCode === '201') {
          this.isCertification = true
          this.certificationMsg = res.content.msg
        } else {
          this.isCertification = false
        }
      } else {
        this.isCertification = false
      }
    },
    // 二级期刊分类改变
    journalTwoChange(code) {
      let arr = this.journalList2.filter(item => item.code === code)
      this.journal2 = code
      this.periodical.subjectId = code;
      this.periodical.subject = arr[0].name;
    },
    // 一级期刊分类改变
    async journalChange(code) {
      this.journal = code
      const resp = await this.$apis.hundredServe.getListByParentCode({
        parentCode: code,
      });
      this.journalList2 = resp.perClaTwoList; // 期刊分类一级下拉选项
    },
    // 获取期刊分类一级列表
    async classificationOneList() {
      const resp = await this.$apis.hundredServe.getPerOneList();
      this.journalList = resp.perClaOneList; // 期刊分类一级下拉选项
    },
    // 创刊时间改变
    changeDate(date) {
      this.periodical.foundedDate = date;
    },
    // 修改认证信息回显
    async getMaDetails() {
      let res = await this.$apis.userServe.getMaDetails();
      // this.$Modal.warning({
      //     title: '不通过原因',
      //     content: res.content.periodicalInfo.cause,
      // });
      // 回显基本信息
      for (const key in this.periodical) {
        if (key === "coreName") {
          this.periodical[key] = [...res.content.periodicalInfo.periodical[key].split(',')]
        } else if(key === 'responsibleDeptList' || key === 'organizerList' || key === 'publishCompanyList') {
          this.periodical[key] = res.content.periodicalInfo.periodical[key].length > 0 ? res.content.periodicalInfo.periodical[key] : this.periodical[key]
        } else if(key === 'subjectId') {
          this.periodical[key] = res.content.periodicalInfo.periodical[key]
          let journal = this.periodical.subjectId.slice(0,2)
          this.classification(journal,this.periodical.subjectId)
        } else {
          this.periodical[key] = res.content.periodicalInfo.periodical[key]
        }
      }
      // 出版地
      this.screeningAddress(this.periodical.publishAddrProvince,this.periodical.publishAddrCity)
      // 回显收录网站
      this.periodicalDatabase = [...res.content.periodicalInfo.periodicalDatabase]
      // 回显资质信息图片和运营者信息
      for (const key in this.periodicalInfo) {
        this.periodicalInfo[key] = res.content.periodicalInfo.periodicalInfo[key]
      }
      this.nameBlur()
    },
    classification(first,second) {
      this.journal2 = second
      this.journalChange(first)
    },
    // 回显出版地址
    screeningAddress(pre, city) {
      this.preList.forEach((item) => {
        if (item.name == pre) this.pre = item.code
      });
      this.handerChange(city)
    },
    handerChangeCity() {
      this.preList.forEach((item) =>
        item.code == this.pre ? (this.periodical.publishAddrProvince = item.name) : ""
      );
      this.cityList.forEach((item) =>
        item.code == this.city ? (this.periodical.publishAddrCity = item.name) : ""
      );
    },
    async handerChange(city) {
      let res = await this.$apis.userServe.cityList({ provinceCode: this.pre });
      this.cityList = res.content.cityList;
      if (city) {
        this.cityList.forEach((item) =>{
          if (item.name == city) this.city = item.code
        });
      }
    },
    async getProList() {
      let res = await this.$apis.userServe.proList();
      this.preList = res.content.provinceList;
    },
    // 校验
    verify(obj) {
      for (const key in obj) {
        if (key === 'advertiseLicense' || key === 'dutyCompilerCertificate' || key === 'coreName') { // 当是收录数据库/责任编辑证/广告许可证时不校验是否为空
          return false 
        } else if(typeof(obj[key]) === 'object') { // 当是主管单位/主办单位/出版单位 校验是否为空方法
          if (obj[key].some(item => item.orgName === '')) return true
        } else { // 当时其他必填项时校验是否为空
          if (obj[key] === '') return true
        }
      }
    },
    // 提交接口
    async sub() {
      await this.nameBlur()
      if (this.isCertification) {
        this.$Message.error("期刊名称有误");
        return
      }
      let periodicalObj = Object.assign({},this.periodical)
      let periodicalInfoObj = Object.assign({},this.periodicalInfo)
      let periodicalDatabaseArr = [...this.periodicalDatabase]
      let subData = {
        periodical: periodicalObj,
        periodicalInfo: periodicalInfoObj,
        periodicalDatabase: periodicalDatabaseArr,
      }

      // 当不是修改提交的时候 删除id
      let userHasData = JSON.parse(sessionStorage.getItem("userHasData"));
      if(userHasData.status !== 2) {
        delete subData.periodical.id 
        delete subData.periodical.adminUser
        delete subData.periodicalInfo.id
      }
      // 将收录数据库数组改为字符串
      subData.periodical.coreName = this.periodical.coreName.join();

      // 校验方法
      if (this.verify(subData.periodical)) {
        this.$Message.error("基本信息中还有未填项");
        return
      }
      if (this.verify(subData.periodicalInfo)) {
        this.$Message.error("资质信息或运营者信息中还有未填项");
        return
      }
      if (subData.periodicalDatabase.some(item => item.url === '' || item.name === '')) {
        this.$Message.error("收录网站不能为空");
        return
      }
      let reg = /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      if (!reg.test(subData.periodicalInfo.operateIdentityCard)) {
        this.$Message.error("身份证格式错误");
        return;
      }

      // 提交
      let res = await this.$apis.userServe.subPeriodical(subData);
      if (res.data.resultCode != 200) {
        this.$Message.error(res.data.resultDesc);
        await this.$router.push("/user");
      } else {
        this.$Message.success("提交成功");
        let data = await this.$apis.loginServe.getUserInfo();
        let userObj = {
          token: sessionStorage.getItem("token"),
          hasLogin: true,
          userInfo: data.content,
        };
        this.$store.commit("loginInfo", userObj);
        await this.$router.push("/user/review");
      }
    },
    async getIncludeList() {
      const resp = await this.$apis.xsjhServe.getIncludeList();
      this.includeList = resp.dbList;
    },
    periodicalLogoSuccess(res) {
      this.periodical.periodicalLogo = res.content.url;
    },
    advertiseLicenceSuccess(res) {
      // this.url = res.content.url;
      this.periodicalInfo.advertiseLicense = res.content.url;
    },
    operateIdentityImgFrontSuccess(res) {
      // this.url = res.content.url;
      this.periodicalInfo.operateIdentityImgFront = res.content.url;
    },
    operateIdentityImgBackSuccess(res) {
      // this.url = res.content.url;
      this.periodicalInfo.operateIdentityImgBack = res.content.url;
    },
    dutyCompilerCertificateSuccess(res) {
      // this.url = res.content.url;
      this.periodicalInfo.dutyCompilerCertificate = res.content.url;
    },
    jobsTrainingCertificateSuccess(res) {
      // this.url = res.content.url;
      this.periodicalInfo.jobsTrainingCertificate = res.content.url;
    },
    pulicationLicenseSuccess(res) {
      // this.url = res.content.url;
      this.periodicalInfo.publicationLicense = res.content.url;
    },
    businessLicenseSuccess(res) {
      // this.url = res.content.url;
      this.periodicalInfo.businessLicense = res.content.url;
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "图片上传过大",
        desc: file.name + "该文件大小超过1M.",
      });
    },
    coverImgSuccess(res) {
      // this.url = res.content.url;
      this.periodical.coverImg = res.content.url;
    },
    delPeriodicalDatabase(field,i) {
      if (field === 'periodicalDatabase') {
        if (this.periodicalDatabase.length === 1) return;
        this.periodicalDatabase.splice(i, 1);
      } else {
        if (this.periodical[field].length === 1) return
        this.periodical[field].splice(i, 1);
      }
    },
    addPeriodicalDatabase(field,i) {
      if (field === 'periodicalDatabase') {
        if (this.periodicalDatabase.length === 10) return;
        if (this.periodicalDatabase[i].url === "" || this.periodicalDatabase[i].name === "") return
        this.periodicalDatabase.push({
          url: "",
          name: "",
        });
      } else {
        if (this.periodical[field][i].orgName === '') return
        this.periodical[field].push({orgName: ""})
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#periodicalRz {
  padding: 50px 0 50px 40px;
  width: 1200px;
  min-height: 2300px;
  background: #ffffff;
  box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.13);

  .submit {
    width: 70px;
    height: 36px;
    line-height: 34px;
    color: #fff;
    background: #007fff;
    border-radius: 8px;
  }

  .title {
    height: 20px;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    margin-bottom: 70px;
  }

  .list {
    display: flex;
    align-items: center;
    margin-top: 10px;

    .upload {
      display: inline-block;
    }

    .img {
      width: 70px;
      height: 98px;
      margin-right: 20px;
    }

    .IDimg {
      width: 296px;
      height: 163px;
      //background: pink;
      border-radius: 6px;
    }

    .key {
      //background: pink;
      font-size: 14px;
      width: 140px;
      margin-right: 20px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      line-height: 48px;
    }
    .netBox {
      display: flex;
      align-items: center;
      margin-bottom: 5px;
    }
    .addIcon {
      margin: 0 10px;
      width: 15px;
      height: 15px;
      line-height: 13px;
      text-align: center;
      font-size: 16px;
      color: #4ec0ff;
      border: 1px dotted #4ec0ff;
      cursor: pointer;
    }
    .subIcon {
      margin-right: 0;
      line-height: 9px;
    }
  }
}
</style>
